<template>
  <header>
    <div class="logo">
      <img src="~@/assets/images/logo.svg" width="150" height="54" alt="Netstar" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

header {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  .logo {
    padding-top: 5em;
    padding-left: 20px;
  }
}
</style>

<script>
export default {
  name: "Header",
};
</script>
